let initChats = (state, { payload }) => {
    payload.forEach((element) => {
        if (element.pins === null) element.pins = [];
        if (element.stars === null) element.stars = [];
    });
    state.chats = payload;
};
export default initChats;
